import React from 'react';
import { Link } from 'react-router-dom';
import './LinkButton.sass';

import { ReactComponent as Arrow } from '../../Icons/arrow-light-right.svg';

interface Props {
	label: string;
	// eslint-disable-next-line react/require-default-props
	isOrange?: boolean;
	isExternal: boolean;
	hrefSource: string;
	// eslint-disable-next-line react/require-default-props
	id?: string;
}

function LinkButton({
	label,
	hrefSource,
	isExternal,
	isOrange = false,
	id = '',
}: Props) {
	return isExternal ? (
		<a
			href={hrefSource}
			target="_blank"
			rel="noreferrer"
			className={`uikit-link-button ${
				isOrange ? 'uikit-link-button--orange' : ''
			}`}
			id={id}
		>
			{label}
			<Arrow />
		</a>
	) : (
		<Link
			to={hrefSource}
			className={`uikit-link-button ${
				isOrange ? 'uikit-link-button--orange' : ''
			}`}
			id={id}
		>
			{label}
			<Arrow />
		</Link>
	);
}

export default LinkButton;
